import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { StorageSessionService } from '../../../core/storage/services/storage.session.service';
import { KEYS } from '../../../core/service/constants/service.constants';

@Injectable()
export class AnalyticsCoreURLService {
	private _domainName: string;
	private _serviceURL: string;

	constructor(private storageSessionService: StorageSessionService) {
		this.domainName = window.location.hostname;
		if (this._serviceURL === undefined || this._serviceURL.lastIndexOf('frequence', 0) === 0) {
			const cachedStorageServiceURL = this.storageSessionService.getServiceURL(KEYS.STORAGE_SERVICE_URL_ID);

			if (cachedStorageServiceURL) {
				this.serviceURL = cachedStorageServiceURL[KEYS.COOKIE_SERVICE_URL];
			} else {
				this.serviceURL = environment.serviceURL;
			}
		} else {
			console.log(
				'AnalyticsCoreURLService:: FATAL ERROR!!! Entering an unexpected condition! Value of Service URL is: ' +
					this.serviceURL
			);
		}
	}

	get domainName(): string {
		return this._domainName;
	}

	set domainName(value: string) {
		this._domainName = value;
	}

	public updateServiceURLForPartnerCNAME(partnerCNAME: string) {
		let re = /analytics-api/;
		this.serviceURL = environment.serviceURL.replace(re, partnerCNAME);
		this.storageSessionService.setServiceURL(
			KEYS.STORAGE_SERVICE_URL_ID,
			KEYS.COOKIE_SERVICE_URL,
			this.serviceURL,
			KEYS.EXPIRES_IN
		);
	}

	set serviceURL(value: string) {
		this._serviceURL = value;
	}

	get serviceURL(): string {
		return this._serviceURL;
	}
}
